export const text = {
  continueAsGuest: 'Continue as Guest',
  guestSuccess: 'Continuing as guest!',
  guestError: 'Could not continue as guest. Please try again.',
};
